/** Ítems del menú admin (rail + topbar). */
export const ADMIN_MENU_ITEMS = [
  { path: '/admin/dashboard', label: 'Panel', icon: 'bi-speedometer2', shortLabel: 'Panel' },
  { path: '/admin/productos', label: 'Productos', icon: 'bi-box-seam', shortLabel: 'Productos' },
  { path: '/admin/compras', label: 'Compras', icon: 'bi-cart-check', shortLabel: 'Compras' },
  { path: '/admin/carritos-abandonados', label: 'Carritos', icon: 'bi-cart-x', shortLabel: 'Carritos' },
  { path: '/admin/facturas', label: 'Facturas', icon: 'bi-receipt', shortLabel: 'Facturas' },
  { path: '/admin/contacto', label: 'Contacto', icon: 'bi-telephone', shortLabel: 'Contacto' },
  { path: '/admin/newsletter', label: 'Newsletter', icon: 'bi-envelope-paper-heart', shortLabel: 'Newsletter' },
  { path: '/admin/usuarios-admin', label: 'Usuarios', icon: 'bi-people', shortLabel: 'Usuarios' },
  { path: '/admin/consultorios', label: 'Consultorios', icon: 'bi-building', shortLabel: 'Consultorios' },
  { path: '/admin/logs', label: 'Actividad', icon: 'bi-journal-text', shortLabel: 'Actividad' },
];

export function isAdminNavActive(pathname, itemPath) {
  if (itemPath === '/admin/dashboard') return pathname === itemPath;
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
}
